import Head from 'next/head';
import { useRouter } from 'next/router';

export default function PageMetadata({
  title,
  description,
  ogImage,
  ogType = 'website',
  children,
}) {
  const router = useRouter();
  const baseUrl = process.env.NEXT_PUBLIC_SITE_URL || 'https://rockalingua.com';

  const canonicalUrl = `${baseUrl}${router.asPath}`;

  const ogImageUrl =
    ogImage ||
    `${process.env.NEXT_PUBLIC_AWS_CLOUDFRONT_HOST}/production/static/img/small-logo.png`;

  const robotsContent =
    process.env.NEXT_PUBLIC_ROCKALINGUA_ENVIRONMENT !== 'production'
      ? 'noindex, nofollow'
      : 'index, follow';

  return (
    <>
      <Head>
        <title>{title}</title>
        {description && <meta name="description" content={description} />}

        <link rel="canonical" href={canonicalUrl} />

        <meta name="viewport" content="width=device-width, initial-scale=1" />

        <meta property="og:type" content={ogType} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:image" content={ogImageUrl} />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={ogImageUrl} />

        <meta name="robots" content={robotsContent} />
      </Head>
      {children}
    </>
  );
}
